import axios from "axios"
import { BlockType } from "shared/types/science35Types"
import { StudentResponse } from "shared/types/teacherTypes"
import { HomeSchoolBlock } from "shared/types/homeschoolTypes"

export type Permission = "DEFAULT" | "CUSTOMER" | "ADMIN" | "EDITING" | "STUDENT" | "TEACHER" | "NOT_BEST_IN_CLASS_API"

export interface InformationReturn {
    permissions: (Permission)[],
    isLoggedIn: boolean
    emailVerified: boolean
    isStudent: boolean
    isSSO: boolean
    studentInfo?: StudentResponse
    isAdmin: boolean
    isStaff: boolean
    trackingEnabled: boolean
    hasStemSimsAccess: boolean
    hasCurriculumAccess: boolean
    hasScience21Access: boolean
    homeschoolBlocks: HomeSchoolBlock[]
    scienceBlocks: BlockType[]
    csrfToken: string
    triggerAuthRefresh: any
    impersonationMode: boolean
}

/**
 * Gets information about the user's authentication
 */
export function information(): Promise<InformationReturn> {
    return axios.get("/api/auth")
        .then((response) => response.data)
}
